import { SubscriptionsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from '../types/TCall';
import type { subscriptionsKeys } from './subscriptionsKeys';

type TParams = QueryFunctionContext<ReturnType<typeof subscriptionsKeys.orgMembersList>>;

export const createFetchSubscriptionOrgMembersQueryFn =
  (call: TCall) =>
  ({
    queryKey: [
      {
        params: { baId, subscriptionId, search },
      },
    ],
    signal,
  }: TParams) =>
    call(() =>
      cancelOnSignal(
        SubscriptionsService.getOrgMembers({
          baId,
          subscriptionId,
          orderBy: 'name',
          orderType: 'asc',
          pageNo: '1',
          pageSize: '10000',
          search,
        }),
        signal,
      ),
    );
